// eslint-disable-next-line import/prefer-default-export
export const AwardEmployeesSteps = Object.freeze({
    Loading: -1,
    GetAwardingRequiredData: 0,
    ExecuteAwarding: 1,
    UpdateEmployeeSelections: 2,
    WrappingUp: 3,
});
